module.exports = __webpack_public_path__ + "static/media/tablet-android.a524ab00.svg";